<template>
  <div class="table-responsive">
    <div>
      <div>
        <h4 class="service-response-h4">
          {{ $t("message.find_partner.corporate_news_search") }}
        </h4>
      </div>
      <template>
        <template v-for="item in response_info">
          <corporateNewsItem :item="item" :mode="mode" />
        </template>
      </template>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import corporateNewsItem from "./helpers/corporate-news-item.vue";
export default {
  components: { corporateNewsItem },
  props: ["data", "mode"],
  data() {
    return {
      response_info: [],
      corporate_search_list_fields: [
        {
          key: "Id",
          label: this.$t("message.find_partner.corporate_news_search_Id"),
        },
        {
          key: "NewsId",
          label: this.$t("message.find_partner.corporate_news_search_NewsId"),
        },
        {
          key: "Source",
          label: this.$t("message.find_partner.corporate_news_search_Source"),
        },
        {
          key: "Title",
          label: this.$t("message.find_partner.corporate_news_search_Title"),
        },
        {
          key: "Url",
          label: this.$t("message.find_partner.corporate_news_search_Url"),
        },
        {
          key: "PublishTime",
          label: this.$t(
            "message.find_partner.corporate_news_search_PublishTime",
          ),
        },
        {
          key: "EmotionType",
          label: this.$t(
            "message.find_partner.corporate_news_search_EmotionType",
          ),
        },
        {
          key: "Category",
          label: this.$t("message.find_partner.corporate_news_search_Category"),
        },
        {
          key: "NewsTags",
          label: this.$t("message.find_partner.corporate_news_search_NewsTags"),
        },
        {
          key: "Content",
          label: this.$t("message.find_partner.corporate_news_search_Content"),
        },
      ],
    };
  },
  mounted() {
    this.response_info = this.data.response_info;
  },
  computed: {},
  watch: {
    data: function (newVal, oldVal) {
      this.response_info = newVal.response_info;
    },
  },
  methods: {
    momentum(d) {
      return moment(d).format("D.MM.Y");
    },
  },
};
</script>
